import React, { PropTypes } from 'react';

import LocalDataPoint from './LocalDataPoint';
import { CDN_PROVIDERS } from '../../constants/cdnConstants';

import { getPath } from './MultiCdnUtils';

const LocalBrowserRow = ({
    image,
    transformation}) =>
    (
        <tr className="border-bottom cdn-your-browser">
            <td className="cdn-your-browser-name">
                <span className="flag-icon" /> Your browser
            </td>
            {
                Object.keys(CDN_PROVIDERS).map((cdnKey, i) =>
                <td
                className="text-center"
                key={i}>
                    <LocalDataPoint path={getPath(image.public_id, transformation, cdnKey)} cdnKey={cdnKey} />
                </td>
                )
            }
        </tr>
    );

LocalBrowserRow.PropTypes = {
    image: PropTypes.string.isRequired,
    transformation: PropTypes.object
};

export default LocalBrowserRow;



/** WEBPACK FOOTER **
 ** ./src/js/components/MultiCdn/LocalBrowserRow.js
 **/